module.exports = __webpack_public_path__ + "img/bigTitle.1b389793.png";